import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';
import OnboardingHelpView from './OnboardingHelpView.vue';

// SiteUp: central de ajuda (mundo Sistema do Hub). Lista toda tela com dica,
// manual e tour, para reler o manual ou refazer o tour sem esperar a dica
// aparecer. So desktop web (useOnboardingSurface).
export const routes = [
  {
    path: frontendURL('accounts/:accountId/ajuda'),
    name: 'help_guides',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: OnboardingHelpView,
  },
];
